package com.milta.core.localization.translations.bg

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Импортиране — Снимка",
    titlePdf = "Импортиране — PDF",
    titleSpreadsheet = "Импортиране — Excel / CSV",
    fileSentSuffix = "изпратено току-що",
    fileWaitingConnectionLabel = "изчаква връзка",
    analysingTitle = "Четене на документа…",
    analysingSubtitle = "Извличането на доставките може да отнеме няколко секунди.",
    analysingSubtitlePdf = "Claude Haiku извлича доставките — това може да отнеме няколко секунди при сканиран PDF.",
    stepFileSent = "Файлът е изпратен",
    stepExtracting = "Извличане на полетата",
    stepReview = "Преглед преди добавяне",
    successTitle = "Доставка открита",
    successSubtitle = "Проверете информацията, преди да я добавите към маршрута.",
    addToRouteButton = "Добави към маршрута",
    scanAnotherButton = "Сканирай друг документ",
    partialTitle = "Почти завършено",
    partialSubtitle = "Едно поле не можа да бъде прочетено от документа.",
    missingFieldPlaceholder = "Да се попълни…",
    partialBannerText = "Част от информацията не можа да бъде прочетена. Можете да потвърдите както е и да я допълните по-късно, или да изпратите по-ясен документ.",
    retryFileButton = "Изпрати друг файл",
    validateAndContinueButton = "Потвърди и продължи",
    errorTitleUnreadable = "Нечетим документ",
    errorTitleMissingFields = "Информацията не е намерена",
    errorTitleNetworkError = "Проблем при анализа",
    errorTitleGeneric = "Анализът неуспешен",
    errorSubtitle = "Не успяхме да открием доставка в този файл.",
    errorBannerSuffixUnreadable = "изображението е твърде тъмно или текстът е отрязан. Направете добре кадрирана и добре осветена снимка или изпратете по-ясен файл.",
    errorBannerSuffixMissingFields = "не беше намерена полезна информация. Проверете съдържанието на файла или изпратете друг.",
    errorBannerSuffixNetworkError = "услугата за анализ срещна мрежов проблем. Опитайте отново след малко.",
    errorBannerSuffixGeneric = "възникна неочаквана грешка по време на анализа. Опитайте отново или изпратете друг файл.",
    retryWithNewFileButton = "Опитай отново с друг файл",
    manualEntryButton = "Въведи ръчно",
    newDocumentButton = "Импортирай нов документ",
    serviceUnavailableTitle = "Услугата временно недостъпна",
    serviceUnavailableSubtitle = "Автоматичният анализ не отговаря в момента.",
    serviceUnavailableBanner = "Опитайте отново след малко или попълнете доставката ръчно междувременно.",
    offlineTitle = "Вие сте офлайн",
    offlineSubtitle = "Вашият файл е готов, но все още не е изпратен.",
    offlineBanner = "Свържете се отново с интернет и стартирайте анализа отново. Нищо не е изпратено към сървъра — нищо не е приспаднато от вашия AI кредит.",
    retryOfflineButton = "Опитай отново — няма връзка",
    unsupportedFormatBanner = "Неподдържан формат на файл. Изберете снимка, PDF или Excel/CSV файл.",
    validationTitle = "Прегледайте доставките",
    fileRejectedTitle = "Файлът не е изпратен",
    fileRejectedSubtitle = "Изберете друг файл, за да продължите.",
    bannerFileRequired = "не е избран файл. Изберете PDF файл, за да продължите.",
    bannerInvalidPdfFormat = "неподдържан формат. Тук се приемат само PDF файлове.",
    bannerFileTooLarge = "файлът е твърде голям. Изберете по-лек PDF файл.",
    chooseAnotherFileButton = "Избери друг файл",
    processingCanLeaveNote = "Файлът ви е изпратен. Можете да напуснете този екран, анализът продължава. Ще намерите импорта си в „Импортиране на доставки“.",
    uploadingPhotoStep = "Изпращане на снимката",
    uploadingFileStep = "Изпращане на файла",
    photoSentStep = "Снимката е изпратена",
    uploadProgress = "%1 от %2",
    uploadingPhotoBanner = "Изпращане. Оставете този екран отворен до края на изпращането: анализът започва веднага щом снимката бъде получена.",
    uploadingFileBanner = "Изпращане. Оставете този екран отворен до края на изпращането: анализът започва веднага щом файлът бъде получен.",
    cancelUploadButton = "Отмяна на изпращането",
    cancelImportButton = "Отмяна на импорта",
    cancelImportDialogTitle = "Да се отмени ли този импорт?",
    cancelImportAnalysingScanMessage = "Анализът спира веднага и към маршрута ви няма да бъде добавена нито една доставка. Вече стартираният анализ остава приспаднат от вашия AI кредит.",
    cancelImportAnalysingFileMessage = "Анализът спира веднага и към маршрута ви няма да бъде добавена нито една доставка. Вече стартираният анализ остава приспаднат от вашия AI кредит.",
    cancelImportConfirmButton = "Да, отмени импорта",
    continueAnalysisButton = "Продължи анализа",
    cancelImportReviewMessage = "Откритите доставки (%s) се изтриват и нито една не се добавя към маршрута ви. Връщате се към избора на източник.",
    cancelImportReviewMessageSingle = "Откритата доставка се изтрива и не се добавя към маршрута ви. Връщате се към избора на източник.",
    continueReviewButton = "Продължи проверката",
    importCancelledNotice = "Импортът е отменен. Не е добавена нито една доставка.",
    serviceUnavailableRetryBanner = "Файлът ви е запазен. Стартирайте анализа отново, без да го изпращате пак, или междувременно въведете доставката ръчно.",
    serviceUnavailableExhaustedBanner = "Този документ не можа да бъде анализиран. Добавете доставките ръчно или започнете отново с нов документ.",
    errorTitleTooLong = "Документът е твърде дълъг",
    errorSubtitleTooLong = "Този документ съдържа твърде много доставки, за да бъде анализиран наведнъж.",
    errorBannerSuffixTooLong = "разделете го на няколко по-кратки файла или въведете доставките ръчно.",
    errorTitleTooLarge = "Документът е твърде голям",
    errorSubtitleTooLarge = "Този документ надвишава размера, който анализът може да обработи.",
    errorBannerSuffixTooLarge = "намалете размера му или го разделете на няколко файла, или въведете доставките ръчно.",
    errorTitleNoDeliveries = "Няма намерени доставки",
    errorSubtitleNoDeliveries = "Документът беше прочетен, но в него не бяха намерени доставки.",
    errorBannerSuffixNoDeliveries = "проверете дали съдържа списък с доставки или ги въведете ръчно.",
    errorTitleSourceExpired = "Файлът е изтекъл",
    errorSubtitleSourceExpired = "Този файл вече не е наличен за нов анализ.",
    errorBannerSuffixSourceExpired = "изберете го отново, за да стартирате анализа.",
    errorTitleOriginRouteDeleted = "Импортът е отменен",
    errorSubtitleOriginRouteDeleted = "Изходният маршрут е изтрит: този импорт е отменен.",
    errorBannerSuffixOriginRouteDeleted = "импортът е отменен, не е добавена нито една доставка.",
    activeImportHeader = "Импорт в ход",
    activeImportAnalysingPill = "Анализ в ход",
    activeImportFailedPill = "Анализът е неуспешен",
    activeImportReadyPill = "Готово за потвърждение",
    activeImportRunningNote = "Само един импорт наведнъж. Изчакайте края на анализа или го отменете, за да импортирате друг документ.",
    activeImportFailedNote = "Само един импорт наведнъж. Стартирайте отново или отменете този импорт, за да импортирате друг документ.",
    activeImportReadyNote = "Импортираните доставки са готови. Докоснете, за да ги потвърдите.",
    activeImportRunningOtherRouteNote = "Анализира се импорт за маршрута от %s. Докоснете, за да отворите този маршрут. Изчакайте края на анализа или го отменете, за да импортирате друг документ.",
    activeImportReadyOtherRouteNote = "Доставките за маршрута от %s са готови. Докоснете, за да отворите този маршрут и да ги потвърдите.",
    activeImportFailedOtherRouteNote = "Импортът за маршрута от %s е неуспешен. Стартирайте отново или отменете този импорт, за да импортирате друг документ.",
    activeImportRunningNewRouteNote = "Анализира се импорт за нов маршрут. Докоснете, за да продължите създаването му. Изчакайте края на анализа или го отменете, за да импортирате друг документ.",
    activeImportReadyNewRouteNote = "Доставките за новия маршрут са готови. Докоснете, за да продължите създаването му и да ги потвърдите.",
    activeImportFailedNewRouteNote = "Импортът за новия маршрут е неуспешен. Стартирайте отново или отменете този импорт, за да импортирате друг документ.",
    activeImportRouteLink = "Маршрут от %s",
    activeImportNewRouteLink = "Нов маршрут (в процес на създаване)",
    weekdayNamesInText = listOf("понеделник", "вторник", "сряда", "четвъртък", "петък", "събота", "неделя"),
)
